import { cn } from '@/lib/utils'

interface LoadingSpinnerProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

export function LoadingSpinner({ className, size = 'md' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-3',
    lg: 'w-10 h-10 border-4',
  }

  return (
    <div
      className={cn(
        "border-white/10 border-t-violet-400 rounded-full animate-spin",
        sizeClasses[size],
        className
      )}
    />
  )
}
